import CartItem from "../../components/cart-item/cart-item.component"
import CartActionsTypes from "./Cart.types"
import {addItemToCart,removeItemFromCart} from './Cart.utils'
import { connect } from "react-redux"

import { clearItemFromCart } from "../../redux/Cart/Cart.actions"

const INITIAL_STATE = {
    hidden : true,
    cartItems : []
}


const cartReducer = (state = INITIAL_STATE , action) => {
    switch(action.type){
        case CartActionsTypes.TOGGLE_CART_HIDDEN:
            return {
                ...state,
                hidden : !state.hidden
            }
        
        


        case CartActionsTypes.ADD_ITEM:
            return {
                ...state,
                cartItems : addItemToCart(state.cartItems,action.payload)
            }

        case CartActionsTypes.REMOVE_ITEM:
            return {
                ...state,
                cartItems : removeItemFromCart(state.cartItems,action.payload)
            }

        case CartActionsTypes.CLEAR_ITEM_FROM_CART:
            return{
                ...state,
                cartItems : state.cartItems.filter(cartItem => cartItem.id !== action.payload.id)
            }

        default:
            return state
    }
}


export default cartReducer